import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Triangle with all applicable features:
 * - 3 altitudes (from each vertex)
 * - 3 medians (from each vertex)
 * - 3 midsegments (connecting midpoints of each pair of edges)
 *
 * Verifiable properties:
 * - Altitudes intersect at the orthocenter
 * - Medians intersect at the centroid (dividing each median 2:1)
 * - Each midsegment is parallel to the opposite side and half its length
 */
export const TRIANGLE_FEATURES_PRESET: GeometryPadWidgetConfig = {
  id: 'triangle-features',
  type: 'geometrypad',
  params: {
    elements: {
      t1: {
        type: 'Triangle',
        params: { a: 5, b: 7, gamma: 60 },
      },
      'altitude-A.t1': { type: 'Altitude', params: { of: 't1', from: 'A' } },
      'median-A.t1': { type: 'Median', params: { of: 't1', from: 'A' } },
      'midseg-AB-CA.t1': { type: 'Midsegment', params: { of: 't1', edges: ['AB', 'CA'] } },
    },
  },
  display: {},
};
